// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const ChevronLeftDoubleIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg width={width} height={height} viewBox="0 0 25 20" xmlns="http://www.w3.org/2000/svg">
          <path fill="inherit" d="M21.846 0c.487 0 .963.147 1.368.421.404.275.72.666.906 1.122a2.536 2.536 0 0 1-.533 2.725L17.943 10l5.644 5.732a2.52 2.52 0 0 1 .72 1.768 2.52 2.52 0 0 1-.72 1.768 2.442 2.442 0 0 1-1.74.732 2.443 2.443 0 0 1-1.742-.732l-7.384-7.5A2.504 2.504 0 0 1 12 10a2.534 2.534 0 0 1 .721-1.768l7.384-7.5c.229-.232.5-.417.799-.542.299-.126.619-.19.942-.19z" />
          <path fill="inherit" d="M9.846 0c.487 0 .963.147 1.368.421.404.275.72.666.906 1.122a2.536 2.536 0 0 1-.533 2.725L5.943 10l5.644 5.732a2.52 2.52 0 0 1 .72 1.768 2.52 2.52 0 0 1-.72 1.768 2.442 2.442 0 0 1-1.74.732 2.443 2.443 0 0 1-1.741-.732l-7.385-7.5a2.534 2.534 0 0 1 0-3.536l7.385-7.5A2.42 2.42 0 0 1 9.846 0z" />
        </svg>
      )
    }
  </Icon>
);

export default ChevronLeftDoubleIcon;
